import { useBlockProps } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @param {Object} props            Properties passed to the function.
 * @param {Object} props.attributes Available block attributes.
 * @return {WPElement} Element to render.
 */
export default function save({ attributes }) {
  const { svgCode, linkTarget, linkUrl, linkTitle } = attributes;

  const blockProps = useBlockProps.save({
    className: `${linkUrl ? 'bf_relative' : ''}`,
  });

  return (
    <div {...blockProps}>
      <span dangerouslySetInnerHTML={{ __html: svgCode }} />
      {linkUrl ? (
        <a
          rel="noopener noreferrer"
          target={linkTarget}
          href={linkUrl}
          title={linkTitle}
          className="bf_tile"
        ></a>
      ) : null}
    </div>
  );
}
